export const ONLINE_ORDERS_LOAD_MORE_AMOUNT = 5
export const STORE_ORDERS_LOAD_MORE_AMOUNT = 5

const ANCHOR_ROUTES = {
  HOME: '/',
}

const LINK_ROUTES = {
  HUB: '/',
}

const STORE_TAB = { id: 'store', text: 'account.digitalreceipts.storereceipts' }
const ONLINE_TAB = { id: 'online', text: 'account.digitalreceipts.onlineorders' }
const TABS = [ONLINE_TAB, STORE_TAB]

export { ANCHOR_ROUTES, LINK_ROUTES, STORE_TAB, ONLINE_TAB, TABS }

export default {
  ONLINE_ORDERS_LOAD_MORE_AMOUNT,
  STORE_ORDERS_LOAD_MORE_AMOUNT,
}
